import CreateRequirementTypeContainer from "./CreateRequirementTypeContainer";
export default CreateRequirementTypeContainer;
